import React, { useState, useEffect } from 'react';

const ImageSlider = ({ images, page }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToNext = () => {
        setCurrentIndex((prev) =>
            prev === images.length - 1 ? 0 : prev + 1
        );
    };

    // 비디오 파일 여부 판별 함수
    const isVideoFile = (url) => {
        const extension = url.split('.').pop().toLowerCase();
        return ['mp4', 'webm', 'mov'].includes(extension);
    };

    // page 값이 바뀔 때마다 currentIndex 업데이트
    useEffect(() => {
        // page가 1 이상, images 배열 길이 이하라고 가정
        // page가 1이면 첫 번째 슬라이드 (index 0)
        // page가 2이면 두 번째 슬라이드 (index 1) ...
        if (page >= 1 && page <= images.length) {
            setCurrentIndex(page - 1);
        }
    }, [page, images]);

    return (
        <div className="relative w-full overflow-hidden">
            <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {images.map((image, index) => (
                    <div
                        key={index}
                        className="min-w-full flex-shrink-0 flex justify-center"
                    >
                        {isVideoFile(image) ? (
                            <video
                                className="w-[90%] h-[600px] object-cover rounded-md"
                                autoPlay
                                loop
                                muted
                            >
                                <source src={image} type="video/mp4" />
                            </video>
                        ) : (
                            <img
                                src={image}
                                alt={`slide ${index}`}
                                className="w-[90%] h-[600px] object-cover rounded-md"
                            />
                        )}
                    </div>
                ))}
            </div>
            {/* 슬라이드 인디케이터 */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                {images.map((_, index) => (
                    <div
                        key={index}
                        className={`w-3 h-3 rounded-full ${
                            currentIndex === index ? 'bg-white' : 'bg-gray-400'
                        }`}
                    />
                ))}
            </div>
        </div>
    );
};

export default ImageSlider;
